import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';

const AddNewNutritionHistory = (props) => {
    const { isOpenNutritionHistory, onClose, nutritionHistoryData, setIsRecordSaved, onDeleteNutritionHistory, patientID, IsEditAllowed  } = { ...props }
    const API_URL = enumUtil.controller.General
    let NutritionHistory_Modal = {
        Notes: nutritionHistoryData.Notes || "",
    }
    let NutritionHistory_Modal_Default = {
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [nutritionHistoryID, setNutritionHistoryID] = useState();
    const [nutritionHistoryValidationModal, setNutritionHistoryValidationModal] = useState(ValidationModal)
    const [nutritionHistorySaveUpdateModal, setNutritionHistorySaveUpdateModal] = useState({})
    const [mainNutritionHistoryModal, setMainNutritionHistoryModal] = useState(NutritionHistory_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onNutritionHistorySaved, setOnNutritionHistorySaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);

    useEffect(() => {
        if (nutritionHistoryData.PatientHistoryID != null) {
            setDel(true)
            setNutritionHistoryID(nutritionHistoryData.PatientHistoryID)
        } else {
            if (!onNutritionHistorySaved) {
                setNutritionHistoryID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(nutritionHistoryID)) {
        }
    }, [nutritionHistoryID])

    const NutritionHistoryValidation = async () => {
        let ValidationModal = {
            NotesVal: FormValidator(
                mainNutritionHistoryModal.Notes,
                enumUtil.enumValidationType.Required,
                'Notes',
            ),
        }
        await setNutritionHistoryValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const addNewNutritionHistory = () => {
        props.setNutritionHistoryData({ PatientHistoryID: null })
        setNutritionHistoryID(null)
        handleClear();
    }
    const handleSaveNutritionHistory = async (type) => {
        if(!IsEditAllowed) return;
        await NutritionHistoryValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setNutritionHistorySaveUpdateModal(nutritionHistorySaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Past Medical History",
                HistorySubType: "Nutrition History",
                ...nutritionHistorySaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: nutritionHistoryID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true)
                        setNutritionHistoryID(response.id)
                        setOnNutritionHistorySaved(true);
                        if (type === "Add Another") {
                            addNewNutritionHistory();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleClear = () => {
        setMainNutritionHistoryModal(NutritionHistory_Modal_Default);
        setNutritionHistorySaveUpdateModal({});
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainNutritionHistoryModal };
        let saveModal = { ...nutritionHistorySaveUpdateModal }
        modal[name] = value
        setMainNutritionHistoryModal(modal)
        for (var property in NutritionHistory_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setNutritionHistorySaveUpdateModal(saveModal)
    }

    const NutritionHistoryName = () => {
        return (
            <p className="heading">Past Medical History</p>
        )
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(nutritionHistoryID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };
    useEffect(() => {
        adjustTextareaHeight();
    }, [mainNutritionHistoryModal.Notes]);
    return (
        <Modal show={isOpenNutritionHistory} onHide={isOpenNutritionHistory} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={NutritionHistoryName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className='patient_payment_tabs'>
                        <div className={`input my-2 ${nutritionHistoryValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Nutrition History</label>
                            <textarea
                                className="form-control overflow-hidden"
                                ref={textareaRef}
                                onInput={adjustTextareaHeight}
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainNutritionHistoryModal.Notes}
                            />
                            {nutritionHistoryValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`}  onClick={() => handleSaveNutritionHistory("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`}  onClick={handleSaveNutritionHistory}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewNutritionHistory